import React from "react";
import {
  Page,
  Layout,
} from '@shopify/polaris';
import "../../styles/shippingreturnpolicy.scss";
import ChoiceHelper from "../../helpers/ChoiceHelper";
import { CsValidationForm } from "../../shared/csValidationForm";
import TableHelper from "../../helpers/TableHelper";
import ShippingAndReturnPolicyRequest from "../../requests/ShippingAndReturnPolicyRequest";
import LegalAppBridge from "../../LegalAppBridge";
import SRGeneralInformation from "./SRGeneralInfomation";
import SRPayment from "./SRPayment";
import SRShipping from "./SRShipping";
import SRReturns from "./SRReturns";
import SRSkeleton from "./SRSkeleton";
import SRCarrier from "./SRCarrier";
import CSPageActions from "../CSPageActions";

export default class ShippingAndReturnPolicy extends React.Component {
  validatorClassGeneral = 'general';
  validatorClassPayment = 'payment';
  validatorClassCarrier = 'carrier';
  validatorClassShipping = 'shipping';
  validatorClassReturns = 'returns';
  savedState = {};
  untrackState = ['init', 'saving', 'validateError', 'windowWidth'];
  unSaveState = this.untrackState;

  shippingTableItemSkeleton = { area: '', method: '', carrier: '', cost_conditions: '' };

  state = {
    init: true,
    saving: false,
    validateError: false,
    // General
    productTypeVirtual: true,
    productTypePhysical: true,
    productTypeServices: true,
    withdrawalPeriod: '',
    maximumDirectCostsForReturns: '',
    // Payment
    refundMethods: [],
    partialRefunds: false,
    warrantyRequiresRMA: false,
    claimPeriod: '',
    durationOfConventionalWarranty: 1,
    // Shipping
    carrierActive: false,
    shippingNational: [],
    shippingNationalOthers: '',
    shippingInternationalExpress: [],
    shippingInternationalExpressOthers: '',
    deliveryTime: "",
    freeShipping: true,
    describeTheConditions: '',
    shippingTable: [this.shippingTableItemSkeleton],
    cutOffTimes: '',
    // Returns
    shippingDueByCustomer: false,
    insuranceRequired: false,
    repairs: false,
    exchanges: false,
    returnAddress: '',
    contactEmail: '',
    contactWebPage: '',
    contactPhone: '',
    contactOther: '',

    // Dynamic fields size
    windowWidth: undefined,
  }

  handleResize = () => this.setState({
    windowWidth: window.innerWidth
  });

  discardChanges = () => {
    this.setState(this.props.getSavedState(this.savedState, this.untrackState));
  }

  componentDidMount() {
    this.handleLoad();
    this.handleResize();
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleLoad = () => {
    ShippingAndReturnPolicyRequest.loadPolicy(
      (response) => {
        if (response.success) {
          this.setState(response.data);
          this.savedState = this.props.getStateToBeSaved(this.state, this.untrackState);
        } else {
          LegalAppBridge.toastError(response.reason);
        }
      },
      () => {
        LegalAppBridge.toastError('Unknown error');
      },
      () => {
        this.setState({ init: false });
      }
    );
  }

  handleSave = () => {
    let validation = true;
    [this.validatorClassGeneral, this.validatorClassPayment, this.validatorClassCarrier, this.validatorClassShipping, this.validatorClassReturns]
      .map(validatorClass => validation = validation && CsValidationForm.validate(validatorClass));

    if (!validation) {
      this.setState({ validateError: true });
    } else {
      this.setState({ saving: true, validateError: false });
      let shippingPolicies = Object.assign({}, this.state);
      this.unSaveState.map(key => delete shippingPolicies[key]);

      ShippingAndReturnPolicyRequest.savePolicy(
        shippingPolicies,
        (response) => {
          if (response.success) {
            LegalAppBridge.toast('Settings saved successfully');
            this.savedState = this.props.getStateToBeSaved(this.state, this.untrackState);
          } else {
            LegalAppBridge.toastError(response.reason);
          }
        },
        () => {
          LegalAppBridge.toastError('Unknown error');
        },
        () => {
          this.setState({ saving: false });
        }
      );
    }
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target ? event.target.value : event });
  }

  handleSelectChange = name => event => {
    const changedValue = event.target ? event.target.value : event;
    this.setState({ [name]: ChoiceHelper.onChange([changedValue], this.state[name]) });
  }

  handleChoiceListChange = name => event => {
    const changedValue = event.target ? event.target.value : event;
    this.setState({ [name]: ChoiceHelper.onChange(changedValue, this.state[name]) });
  }

  handleArrayChange = (name, index, field) => event => {
    const changedValue = event.target ? event.target.value : event;
    this.setState({ [name]: TableHelper.onChange(changedValue, this.state[name], index, field) });
  }

  handleArrayAdded = name => () => {
    this.setState({ [name]: [...this.state[name], this[name + 'ItemSkeleton']] });
  }

  handleArrayRemoved = (name, removeIndex) => () => {
    this.setState({ [name]: TableHelper.removeRow(this.state[name], removeIndex) });
  }

  render() {
    const state = this.state;

    if (state.init) {
      return <SRSkeleton />
    }

    return (
      <Page fullwidth>
        <Layout>
          <SRGeneralInformation
            validatorClass={this.validatorClassGeneral}
            productTypeVirtual={state.productTypeVirtual} productTypePhysical={state.productTypePhysical}
            productTypeServices={state.productTypeServices}
            withdrawalPeriod={state.withdrawalPeriod}
            maximumDirectCostsForReturns={state.maximumDirectCostsForReturns}
            handleChange={this.handleChange}
          />

          <SRPayment
            validatorClass={this.validatorClassPayment}
            refundMethods={state.refundMethods}
            partialRefunds={state.partialRefunds}
            warrantyRequiresRMA={state.warrantyRequiresRMA}
            claimPeriod={state.claimPeriod} durationOfConventionalWarranty={state.durationOfConventionalWarranty}
            handleChange={this.handleChange} handleSelectChange={this.handleSelectChange}
          />

          <SRCarrier
            validatorClass={this.validatorClassCarrier}
            windowWidth={state.windowWidth}
            carrierActive={state.carrierActive}
            shippingNational={state.shippingNational} shippingNationalOthers={state.shippingNationalOthers}
            shippingInternationalExpress={state.shippingInternationalExpress}
            shippingInternationalExpressOthers={state.shippingInternationalExpressOthers}
            deliveryTime={state.deliveryTime}
            handleChange={this.handleChange} handleChoiceListChange={this.handleChoiceListChange}
          />

          <SRShipping
            validatorClass={this.validatorClassShipping}
            freeShipping={state.freeShipping} describeTheConditions={state.describeTheConditions}
            shippingTable={state.shippingTable}
            cutOffTimes={state.cutOffTimes}
            handleChange={this.handleChange}
            handleArrayChange={this.handleArrayChange}
            handleArrayAdded={this.handleArrayAdded} handleArrayRemoved={this.handleArrayRemoved}
          />

          <SRReturns
            validatorClass={this.validatorClassReturns}
            shippingDueByCustomer={state.shippingDueByCustomer} insuranceRequired={state.insuranceRequired}
            repairs={state.repairs} exchanges={state.exchanges}
            returnAddress={state.returnAddress}
            contactEmail={state.contactEmail} contactWebPage={state.contactWebPage}
            contactPhone={state.contactPhone} contactOther={state.contactOther}
            handleChange={this.handleChange}
          />
        </Layout>

        <CSPageActions
          validateError={state.validateError} saving={state.saving}
          showSaveBar={Object.keys(this.savedState).length && !this.props.shallowCompareEqual(this.savedState, state, this.untrackState)}
          handleSave={this.handleSave} discardChanges={this.discardChanges} handleLoad={this.handleLoad}
        />
      </Page>
    )
  }
}
